// @flow
/**
 * User: Mike Chung
 * Date: 16/1/2018
 * Time: 10:07 PM
 */
import React, {Component, Fragment} from 'react';
import SearchForm from "./SearchForm";
import type {EBadgeQueryCriteria, SortDirection, SortOption} from "../model/ebadge/EBadgeQueryCriteria";
import EBadge from "../model/ebadge/EBadge";
import * as _ from "lodash";
import {Alert, Nav, NavItem, NavLink, Progress} from "reactstrap";
import {NavLink as NLink, Route} from "react-router-dom";
import SsoUser from "../model/sso/SsoUser";
import EBadgeQueryResult from "./ebadge/EBadgeQueryResult";
import SsoUserQueryResult from "./sso/SsoUserQueryResult";
import FairConfig from "../model/fair/FairConfig";
import type {SsoUserQueryCriteria} from "../model/sso/SsoUserQueryCriteria";
import type {Location} from "../types/ReactRouterTypes";
import * as queryString from "query-string";
import {Country} from "../model/Country";
import RoundedSpinner from "./util/spinner/RoundedSpinner";
import type {Warning} from "../reducers/EBadgeQueryReducer";
import Layout from "./Layout";

export type Caller = {
    operator: string,
    comment: string,
    language: "EN"
}

export type QueryPageStateProps = {
    eBadgeTotalResultCount: number,
    ssoUserTotalResultCount: number,
    eBadges: Array<EBadge>,
    ssoUsers: Array<SsoUser>,
    eBadgeError?: any,
    eBadgeWarning?: Warning,
    ssoUserError?: any,
    isEBadgesLoading: boolean,
    isSsoUsersLoading: boolean,
    fairConfigs: Array<FairConfig>,
    countries: Array<Country>,
    fairConfigsByProjectCode: {
        [projectCode: string]: {
            [year: string]: FairConfig
        }
    },
    generatePageLink: (page: number) => Location,
    generateSortLink: (sort: SortOption, direction: SortDirection) => Location,
    currentSort?: SortOption,
    currentSortDirection?: SortDirection,
    caller: Caller
}

export type QueryPageDispatchProps = {
    onSearchCriteriaChanged: (search: string, caller: Caller) => any,
    unlockEBadge: (registrationCode: string, caller: Caller) => any,
    resetResult: () => any
}

export type QueryPageOwnProps = {
    location: Location,
    history: {
        push: (path: Location | string) => any
    }
}

type QueryPageProps = QueryPageOwnProps & QueryPageStateProps & QueryPageDispatchProps;

export const QUERY_PAGE_PAGE_TITLE = "e-Badge and SSO Management";

class QueryPage extends Component<QueryPageProps> {

    onFormSubmit: (form: EBadgeQueryCriteria & SsoUserQueryCriteria) => any;
    clearResult: () => any;

    constructor(props: QueryPageProps) {
        super(props);
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.clearResult = this.clearResult.bind(this);
    }

    componentDidMount() {
        if (!_.isEmpty(this.props.location.search)) {

            this.props.onSearchCriteriaChanged(this.props.location.search, this.props.caller);
        }
    }

    componentDidUpdate(prevProps: QueryPageProps) {

        if (this.props.location !== prevProps.location) {
            window.scrollTo(0, 0);
        }

        if (!_.isEqual(this.props.location.search, prevProps.location.search) && this.props.location.search) {

            this.props.onSearchCriteriaChanged(this.props.location.search, this.props.caller);
        }
    }

    componentWillUnmount() {
        this.props.resetResult();
    }

    onFormSubmit(form: EBadgeQueryCriteria & SsoUserQueryCriteria & { cQw08la1wX: any }) {

        form.page = 1;
        form['cQw08la1wX'] = new Date().getTime();

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: `?${queryString.stringify(_.omit(form, 'target'))}`
        });
    }

    clearResult() {
        this.props.resetResult();
        this.props.history.push({
            pathname: this.props.location.pathname,
            search: ""
        });
    }

    render() {
        return (
            <Layout {...this.props} title={QUERY_PAGE_PAGE_TITLE}>
                <SearchForm countries={this.props.countries} onSubmit={this.onFormSubmit} clearResult={this.clearResult}
                            fairConfigs={this.props.fairConfigs}
                            isLoading={this.props.isEBadgesLoading || this.props.isSsoUsersLoading}
                            onQrCodeScan={(registrationCode) => this.props.history.push(`/query/ebadges?cQw08la1wX=${new Date().getTime()}&page=1&pageItem=20&registrationCode=${registrationCode}`)}/>
                <Nav tabs>
                    <NavItem>
                        <NavLink tag={NLink} to={{pathname: "/query/ebadges", search: this.props.location.search}}>
                            {this.props.isEBadgesLoading &&
                            <RoundedSpinner/>
                            }
                            <span className={"pl-1"}>Registration</span>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink tag={NLink} to={{pathname: "/query/sso", search: this.props.location.search}}>

                            {this.props.isSsoUsersLoading &&
                            <RoundedSpinner/>
                            }
                            <span className={"pl-1"}>SSO</span>
                        </NavLink>
                    </NavItem>
                </Nav>
                {this.props.isEBadgesLoading &&
                <Route exact path={'/query/ebadges'} render={() => <Progress animated color="danger" value="100"/>}/>
                }
                <Route exact path={'/query/ebadges'} render={() => {

                    if (!_.isEmpty(this.props.eBadges)) {
                        return (
                            <Fragment>
                                {this.props.eBadgeWarning &&
                                <Alert color="warning">
                                    {_.get(this.props, "eBadgeWarning.message")}
                                </Alert>
                                }
                                <EBadgeQueryResult {...this.props} totalCount={this.props.eBadgeTotalResultCount}
                                                   generatePageLink={this.props.generatePageLink} generateSortLink={this.props.generateSortLink}
                                                   currentPage={queryString.parse(this.props.location.search).page || 1}/>
                            </Fragment>
                        )
                    } else if (this.props.eBadgeError) {
                        return (
                            <Alert color="danger">
                                {_.get(this.props, "eBadgeError.message", "Server Error")}
                            </Alert>
                        );
                    } else if (this.props.eBadgeTotalResultCount > -1) {
                        return (<Alert color={"warning"}>No Record Found!</Alert>);
                    } else {
                        return null;
                    }
                }}/>
                {this.props.isSsoUsersLoading &&
                <Route exact path={'/query/sso'} render={() => <Progress animated color="danger" value="100"/>}/>
                }
                <Route exact path={'/query/sso'} render={() => {

                    if (!_.isEmpty(this.props.ssoUsers)) {
                        return (

                            <SsoUserQueryResult {...this.props} totalCount={this.props.ssoUserTotalResultCount}
                                                generateLink={this.props.generatePageLink}
                                                currentPage={queryString.parse(this.props.location.search).page || 1}/>
                        )
                    } else if (this.props.ssoUserError) {

                        return (
                            <Alert color="danger">
                                {_.get(this.props, "ssoUserError.message", "Server Error")}
                            </Alert>
                        );
                    } else if (this.props.ssoUserTotalResultCount > -1) {
                        return (<Alert color={"warning"}>No Record Found!</Alert>);
                    } else {
                        return null;
                    }
                }}/>
            </Layout>
        );
    }
}

export default QueryPage;


// WEBPACK FOOTER //
// ./src/components/QueryPage.js